module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAAeCAIAAABoq03CAAABL0lEQVR4AWJ8zKjNQDJgZPjPiGAx/n3HyiN9ahG/vgYTA+ng/3+G/wz/mBiBev+8+3TdyFvk4VtGBqZfjAzMjIykGgY05N8/xncKUornl3LxCTMw/QNaALMI6Fhka/9j9xtQGOglhn+szCxfLt64axch9B3Qbh1o1g4FURj+15x73/+Fu2d1lDKq0YAjWB+CyAi/bRudYpTb+0OJb5Jg/+en4i2iiIRO6EjohE7oeId/PJhtLki6GvngNC2VmwLEHuMvwmYx/w9lTlHer2mWPSSUE52rI6EjoRM6Ejqhs0c/ke2LnVqFSqVRHLmEjIx1axMXQ0IM1MPzpAH3Hn8hfuWc6FwdCR0JndCR0AmdPfr5bLM0HoDECzDD4iajUSpA4oq/5ETn6kjoSOiEjts+AXr7aFtLlQz4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brand_stripes.png
// module id = K3uo
// module chunks = 1 2 3